// import React from 'react';
// import './index.css';
// import "./config/i18n";
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import ReactDOM from 'react-dom/client'
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap/dist/js/bootstrap.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { LanguageProvider } from './store/language-context';

// const queryClient = new QueryClient();

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <LanguageProvider>
//       <App />
//       </LanguageProvider>
//     </QueryClientProvider>
//   </React.StrictMode>
// );

// reportWebVitals();
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './config/i18n';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LanguageProvider } from './store/language-context';
import InternetStatusChecker from './components/Check-Internet/internet-checker';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 300000, // 5 minutes
      retry: false,
      cacheTime: 300000 // 5 minutes
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <InternetStatusChecker fallback={<div className="alert alert-danger text-center">No Internet Connection</div>}>
          <App />
         
        </InternetStatusChecker>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
